import { Type } from '@angular/core';
import { DynamicComponentBase } from './dynamic-component-base.component';

export class DynamicComponentItem<T> {
  constructor(public component: Type<DynamicComponentBase<T>>, public data: T) {}
}
